import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/calendar-times': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0l-53.7-53.8-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17l-53.8 53.8 53.7 53.7c4.8 4.7 4.8 12.3 0.1 17zM448 112v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h48v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zM400 458v-298h-352v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/calendar-times.js
// module id = 1701
// module chunks = 0